import {FastField, getIn, useField, useFormikContext} from "formik";
import React, {Fragment} from "react";

const HiddenDependentField = ({...props}) => {
    const {
        values,
        touched,
        initialValues,
        setFieldValue
    } = useFormikContext();
    const [field] = useField(props);
    const dependencyValue = getIn(values, props.dependency);
    const initialValue = getIn(initialValues, props.name);

    React.useEffect(() => {
        if (getIn(touched, props.dependency)) {
            //Tried to make this general by passing in a props.test value. That generates a react warning with booleans
            //and interferes with us getting shit done, so it looks like I engaged in a bit of premature generalization.
            if (Object.is(dependencyValue, true)) {
                setFieldValue(props.name, props.newvalue);
            } else {
                setFieldValue(props.name, initialValue);
            }
        }
    }, [props.newvalue, props.name, props.dependency, touched, dependencyValue, initialValue, setFieldValue]);
    return (
        <>
            <FastField
                {...field}
                {...props}
                type={"hidden"}
            />
        </>
    );
}

export default HiddenDependentField;